import axios from "axios";
const podcastUrlMF = "https://youtube.googleapis.com/youtube/v3/playlistItems";
const queryOptionsPodcasts = {
  part: "snippet",
  maxResults: 999,
  playlistId: "PLQprSxSE3JXmCqRrw-5EpjHZfeajFOxr5",
  key: "AIzaSyB18_3gXvbDkhx27VM0TOWSi29kUxQfOgw",
};
var podcastsItem = [];

export default {
  listPodcastsMF(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(podcastUrlMF, { params: queryOptionsPodcasts })
        .then((response) => {
          podcastsItem = response.data.items;
          podcastsItem = podcastsItem.sort(
            (a, b) => b.snippet.position - a.snippet.position
          );
          podcastsItem = podcastsItem.filter(function (obj) {
            return obj.snippet.title !== "Private video";
          });
          podcastsItem = podcastsItem.slice(0, 10);
          context.commit("setPodcastsMF", podcastsItem);
          resolve(podcastsItem);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
